import { gql } from 'apollo-boost';

export const GET_CLASS_BOOMBASSADORS = gql`
    query getClassBoombassadors(
        $studentsClassId: ID!
        $startDate: String!
        $endDate: String!
    ) {
        getClassBoombassadors(studentsClassId: $studentsClassId) {
            id
            boomerAvatarUrl
            firstName
            lastName
            flagType
            updatedAt
            readsLogged(startDate: $startDate, endDate: $endDate) {
                id
                lastLogged
                readsLogged
            }
        }
    }
`;

export const GET_BOOMBASADORS_WEEKLY_STATS = gql`
    query studentsClass($id: ID!, $startDate: String!, $endDate: String!) {
        studentsClass(id: $id) {
            id
            boombassadorWeeklyStats(startDate: $startDate, endDate: $endDate) {
                numberOfBoombassadors
                statsPerWeek
            }
        }
    }
`;
